import React from 'react'

/**
 * MiniPill — the mono micro-pill that carries meta on a bullet row.
 *
 * Families (the `kind` prop selects the visual variant):
 *  - State:     'decision' | 'parked' | 'discussed' | 'to-discuss' | 'agreed' | 'open' | 'answered'
 *  - Direction: 'manager-to-report' | 'report-to-manager'
 *  - Rank:      'rank' (label carries the ordinal text)
 *  - Risk:      'at-risk' | 'on-track'
 *  - Live:      'live'      (pulsing moss dot)
 *  - Reveal:    'awaiting'  (mustard) → 'revealed' (moss)
 *
 * Phase E adds the `tone` prop for card-local colour classification labels
 * that carry no cross-card semantic weight (severity, source, type, etc.).
 * `tone` accepts a palette name: 'rust' | 'mustard' | 'moss' | 'clay' | 'berry' | 'olive'.
 * When `tone` is set without `kind`, data-kind defaults to "label" so test
 * selectors have a stable target.
 *
 * Always lowercase, mono, 9.5px. One MP per concept. Two on a row is fine;
 * three is a smell.
 *
 * Spec: claude_design/design-system/primitives.html §8.2
 * Decisions: design-takeover-copy-decisions.md §5
 */
export function MiniPill({ kind, tone, as: Tag = 'span', className = '', children, ...rest }) {
  const resolvedKind = kind ?? (tone ? 'label' : 'discussed')
  const toneClass = tone ? `mp--tone-${tone}` : ''
  const kindClass = `mp--${resolvedKind}`
  const classes = ['mp', kindClass, toneClass, className].filter(Boolean).join(' ')
  return (
    <Tag
      className={classes}
      data-kind={resolvedKind}
      {...(tone != null ? { 'data-tone': tone } : {})}
      {...rest}
    >
      {children}
    </Tag>
  )
}
